export class FiltrosComprobanteIF{
    IdProv : string = '';
    Tipo :string = '';
    Moneda: string = '';
    FechaInicial : string = '';
    FechaFinal : string = '';
    Estado : string = '';
 }